import React from 'react'
import store from '../../store'
import { setFinalScores } from '../slices/finalScores'
import { NA } from '../constants/scores'

export default function calculateFinalScores(travellerType, scores) {
  if (Object.keys(scores).length) {
    // Filter out the keys, which have valid scores
    const fileteredScores = Object.keys(scores).filter(
      (key) => scores[key] !== NA
    )

    const sum = fileteredScores.reduce((sum, key) => sum + scores[key], 0)
    if (fileteredScores.length) {
      const avg = (sum / fileteredScores.length).toFixed(1)
      store.dispatch(
        setFinalScores({ field: travellerType, value: Number(avg) })
      )
    } else {
      // If all scores are NA, then final score is NA
      store.dispatch(setFinalScores({ field: travellerType, value: NA }))
    }
  }
}
